
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.333 12h5.334v-1.333H5.333V12zm0-2.667h5.334V8H5.333v1.333zM4 14.667c-.367 0-.68-.131-.942-.392a1.284 1.284 0 01-.391-.942V2.667c0-.367.13-.681.391-.942.262-.261.575-.392.942-.392h5.333l4 4v8c0 .367-.13.68-.391.942a1.284 1.284 0 01-.942.392H4zM8.667 6H12L8.667 2.667V6z"}})])
          )
        }
      }
    